import { render, staticRenderFns } from "./BrokerAccounts.vue?vue&type=template&id=1653e6fc&"
import script from "./BrokerAccounts.vue?vue&type=script&lang=js&"
export * from "./BrokerAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BrokerAccounts.vue?vue&type=style&index=0&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VRow,VSwitch})
